var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHomeScreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_375_29643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.46 1.66C12.32 1.56 12.16 1.5 11.99 1.5C11.82 1.5 11.66 1.56 11.52 1.66L0.75 10.06L1.68 11.24L3 10.22V19.5C3 19.9 3.16 20.28 3.44 20.56C3.72 20.84 4.1 21 4.5 21H9.48V19.5H4.5V9.05L12 3.2L22.32 11.25L23.02 10.36L23.25 10.07L12.46 1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.08 11.83C11.45 11.83 10.93 12.34 10.93 12.98V20.16C10.93 20.79 11.44 21.31 12.08 21.31H15.42V22.6H13.63V24H21.31V22.6H19.52V21.31H22.86C23.49 21.31 24.01 20.8 24.01 20.16V12.98C24.01 12.35 23.5 11.83 22.86 11.83H12.08ZM16.82 22.6V21.31H18.11V22.6H16.82ZM22.6 13.23V19.91H12.33V13.23H22.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_375_29643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeScreen);
export default __webpack_public_path__ + "static/media/ic-home-screen.a6593d9b8da8468d029b3043df649ede.svg";
export { ForwardRef as ReactComponent };